import { Injectable } from '@angular/core';
import { IPageTeaser } from 'src/models/page-teaser.model';
import { AppState, IPageTeaserState } from '../app.state';
import { EntitySelector } from '../entity.selector';

@Injectable()
export class PageTeaserSelector extends EntitySelector<IPageTeaser, IPageTeaserState> {
	protected stateSelector = (state: AppState): IPageTeaserState => state.pageTeaser;
}
